import { makeRequest } from 'utils/requestLogger';

export default (studentID, liveID) =>
  makeRequest('post', `/api/live_discussions/${liveID}/switch_student`, {
    id: studentID,
  });



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/switchStudent.js